import React from 'react';
import { API_ROOT } from '../../../../baseUrls';
import { getSpacecastSettings } from '../../../../state/actions/getDataActions';
import { setSpacecastSetting } from '../../../../state/actions/updateDataActions';
import './PersonalStats.scss';
import { connect } from 'react-redux';
import { Button, Checkbox } from '@mui/material';
import Loader from '../../../organisms/loader/Loader';

class PersonalStats extends React.Component {
  state = {
    stats: {},
  };

  componentDidMount() {
    this.props.getSpacecastSettings();
    fetch(`${API_ROOT}/mindfiles/${this.props.mindfile.id}/personal-stats`, {
      method: 'GET',
      credentials: 'include',
    })
    .then((resp) => {
      resp.json().then(stats => {
        this.setState({ stats });
      })
      .catch(error => {
        console.error(error);
      })
    })
    .catch((error) => {
      console.error(error);
    });
  }

  renderEnabled() {
    const settings = [
      ['Profile', 'spacecast_profile'],
      ['Video', 'spacecast_video'],
      ['Audio', 'spacecast_audio'],
      ['Documents', 'spacecast_documents'],
      ['Images', 'spacecast_images'],
      ['Biometrics', 'spacecast_biometrics'],
      ['Posts', 'spacecast_post'],
    ].map(
      ([displayName, name], key) => {
        const id = `spacecast-personal-stats-setting-${name}`;
        return (
          <li key={key}>
            <Checkbox
              id={id}
              checked={this.props.settings[name] ? true : false}
              onChange={event => this.props.setSpacecastSetting(name, event.target.checked)}
            />
            <label htmlFor={id}>{displayName}</label>
          </li>
        );
      }
    );
    const stats = [];
    if (this.state.stats['period']) {
      stats.push(
        <dt key='dt_days'>With the current number of spacecasters, your bemes will spacecast every:</dt>,
        <dd key='dd_days'>{this.state.stats['period']}</dd>
      );
    }
    if (this.state.stats['early_date']) {
      stats.push(
        <dt key='dt_early_date'>Your earliest spacecast was at:</dt>,
        <dd key='dd_early_date'>{this.state.stats['early_date']}</dd>
      );
      stats.push(
        <dt key='dt_early_distance'>Distance of your earliest spacecast from Earth:</dt>,
        <dd key='dd_early_distance'>{this.state.stats['early_distance']} light years</dd>
      );
      if (this.state.stats['past_star_name']) {
        stats.push(
          <dt key='dt_past_star_name'>Your earliest spacecast reached {this.state.stats['past_star_name']}:</dt>,
          <dd key='dd_past_star_name'>{this.state.stats['past_star_ago']} days ago</dd>
        );
      }
    } else if (this.state.stats['next']) {
      stats.push(
        <dt key='dt_next'>Your next spacecast is scheduled to begin:</dt>,
        <dd key='dd_next'>{this.state.stats['next']}</dd>
      );
    }
    return(
      <div id="spacecast-personal-stats">
        <h1>Personal Stats</h1>
        <div id="spacecast-personal-stats-top-boxes">
          <fieldset className="spacecast-personal-stats-top-box">
            <legend>Spacecast Settings</legend>
            <p>Please choose the bemes you would like to spacecast:</p>
            <ul id="spacecast-personal-stats-settings">{settings}</ul>
          </fieldset>
          <fieldset className="spacecast-personal-stats-top-box">
            <legend>Statistics</legend>
            {stats.length > 0 ? <dl>{stats}</dl> : <p>Loading statistics...</p>}
          </fieldset>
        </div>
        <div id="spacecast-personal-stats-main" className="spacecast-personal-stats-center-box">
          <div id="spacecast-personal-stats-inner" className="spacecast-personal-stats-center-box-inner">
            <p><strong>Nearby stars that will receive spacecasts</strong></p>
            <img src={`${API_ROOT}/mindfiles/${this.props.mindfile.id}/spacecast/stats_map`} alt="stats map" style={{maxWidth: '100%'}} />
          </div>
        </div>
        <div className="spacecast-personal-stats-center-box">
          <div className="spacecast-personal-stats-center-box-inner">
            You can stop all spacecasting of your bemes:
            <Button
              variant="contained"
              color="secondary"
              style={{margin: '1em'}}
              onClick={() => this.props.setSpacecastSetting('spacecast', false)}
            >
              Disable Spacecasting
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderDisabled() {
    return(
      <div id="spacecast-personal-stats">
        <div id="spacecast-personal-stats-main" className="spacecast-personal-stats-center-box">
          <div className="spacecast-personal-stats-center-box-inner" style={{padding: '1em 2em'}}>
            <p><strong>Spacecasting is not enabled for your mindfile</strong></p>
            <p>Use the button below to turn on spacecasting for your mindfile.</p>
            <Button
              variant="contained"
              color="primary"
              style={{margin: '1em'}}
              onClick={() => this.props.setSpacecastSetting('spacecast', true)}
            >
              Enable Spacecasting
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.settings.spacecast !== undefined) {
      return this.props.settings.spacecast ? this.renderEnabled() : this.renderDisabled();
    } else {
      return <Loader />;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth,
    settings: state.spacecastSettings,
    canEdit: state.isCurrentMindfileContributor,
    mindfile: state.mindfile,
  };
}

const mapDispatchToProps = {
  getSpacecastSettings,
  setSpacecastSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalStats);
